export default "<div class=\"loading\">\n  <mat-spinner></mat-spinner>\n</div>\n"